import { useEffect } from "react";

import useIntelligenceSettings from "shared/Intelligence/useIntelligenceSettings";

import useChatStore from "../store/useStore";
import { ChatMode } from "../types";

const useAvailableChatModes = () => {
  const { canUseInfraAssistantBuildMode: buildModeEnabled } = useIntelligenceSettings();

  const currentMode = useChatStore((state) => state.mode);
  const setMode = useChatStore((state) => state.setMode);

  useEffect(() => {
    if (currentMode === ChatMode.BUILD && !buildModeEnabled) {
      setMode(ChatMode.ASK);
    }
  }, [buildModeEnabled, currentMode, setMode]);

  return { buildModeEnabled };
};

export default useAvailableChatModes;
